import { Building2, Keyboard, RefreshCw } from "lucide-react";
import { Button } from "@/components/ui/button";
import Typeahead from "@/components/Typeahead";

export const focusTid = (t) => document.querySelector(`[data-testid="${t}"]`)?.focus();

export const CompanyStage = ({ onPick, noun = "bill" }) => (
  <div className="panel p-6 sm:p-10 max-w-3xl fade-up" data-testid="company-select-stage">
    <div className="flex items-start gap-4">
      <div className="w-11 h-11 rounded bg-emerald-50 text-emerald-800 flex items-center justify-center shrink-0"><Building2 className="w-5 h-5" /></div>
      <div className="flex-1">
        <div className="eyebrow mb-1">Step 1 of 2</div>
        <h2 className="text-xl font-semibold text-slate-900">Select the company for this entry session</h2>
        <p className="text-sm text-slate-500 mt-1">Type to search by name, code or VAT number. Use ↑ ↓ and Enter to select. Every {noun} you enter next is recorded for this company.</p>
        <div className="mt-5">
          <Typeahead endpoint="/clients" labelKey="company_name" value={null} onSelect={onPick} autoFocus placeholder="Search company…"
            meta={(r) => `${r.code} · ${r.vat_number}`} testid="company-typeahead-input" />
        </div>
      </div>
    </div>
  </div>
);

export const SessionBanner = ({ client, onChange }) => (
  <div className="mb-5 panel px-4 py-3 flex flex-wrap items-center gap-x-6 gap-y-2 border-emerald-200 fade-up" data-testid="entry-session-banner">
    <div className="flex items-center gap-3">
      <div className="w-9 h-9 rounded bg-emerald-800 text-white flex items-center justify-center"><Building2 className="w-4 h-4" /></div>
      <div>
        <div className="eyebrow">Entry session · company</div>
        <div className="font-semibold text-slate-900" data-testid="session-company-name">{client.company_name}</div>
      </div>
    </div>
    <div className="text-xs text-slate-500 num">{client.code} · VAT {client.vat_number}</div>
    <div className="hidden md:flex items-center gap-1.5 text-[11px] text-slate-400"><Keyboard className="w-3.5 h-3.5" />Enter → next field · ↑↓ suggestions · Ctrl+Enter save</div>
    <Button size="sm" variant="outline" className="ml-auto" onClick={onChange} data-testid="change-company-button"><RefreshCw className="w-3.5 h-3.5 mr-1.5" />Change company</Button>
  </div>
);
